import styles from './Footer.module.css'

const Footer = () => {
  return (
    <footer className={styles.footer}>
        <span>Desenvolvido por CFA</span>
    </footer>
  )
}

export default Footer